// Models
import Model from './Model'

class Account extends Model {
  get schema () {
    return [
      'assetType',
      'createdAt',
      'id',
      'type',
      'walletId'
    ]
  }
}

export const ACCOUNT_ASSET_TYPES = {
  ACTIVE: 'ACTIVE',
  PASSIVE: 'PASSIVE'
}

export default Account
